import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    fetchEstadosLiquidaciones,
    fetchLiquidacionesBusqueda,
    limpiarLiquidacionesBusqueda,
    setFiltroLiquidaciones
} from '../../../../actions/LiquidacionesActions';
import {
    putEliminaLiquidacionFinal
} from '../../../../api/axios.js';
import { fetchSellersFilterLiquidaciones } from '../../../../actions/sellersActions';
import LiquidacionesListItems from './LiquidacionesListItems';
import { customStyleFilterWrap, DropDownArrow, filterSelectMenuPortalProps } from "../../../../template/CustomStyle";
import { toast } from '../../../../utilities/appToast';
import Select from 'react-select';
import { fechaLimite, filtroMedioMes } from '../../../../utilities/fechasFiltro';
import { limpiarFiltros } from '../../../../actions/generalActios.js';
import BigSpinner from '../../../General/BigSpinner.js';
import SafeReactPaginate from '../../../General/SafeReactPaginate';
import '../../../General/AdminListCard.css';
import '../../shared/liquidacionesModule.css';
import LiquidacionesPageHeader from '../../shared/LiquidacionesPageHeader';
import LiquidacionesFilterCard from '../../shared/LiquidacionesFilterCard';
import LiquidacionesFilterActions from '../../shared/LiquidacionesFilterActions';
import { LiquidacionesBtnCrear } from '../../shared/LiquidacionesButtons';
import './LiquidacionDetalleTabla.css';
import { agregarEstadoCalculada } from '../../shared/liquidacionEstados';

// Wrapper para usar hooks en class component
function ListLiquidacionesWrapper(props) {
    const navigate = useNavigate();
    return <ListLiquidaciones {...props} navigate={navigate} />;
}

const fechaFiltro = filtroMedioMes();
const fechaDesdeMinima = fechaLimite();

const disabledFilterSelectStyles = {
    ...customStyleFilterWrap,
    control: (base, state) => ({
        ...customStyleFilterWrap.control(base, state),
        backgroundColor: state.isDisabled ? '#f4f6f8' : '#fff',
        border: `1px solid ${state.isDisabled ? '#ced4da' : state.isFocused ? '#20aee3' : '#cfd7e0'}`,
        boxShadow: state.isDisabled
            ? 'none'
            : state.isFocused
                ? '0 0 0 3px rgba(32, 174, 227, 0.2)'
                : '0 1px 2px rgba(15, 23, 42, 0.04)',
        cursor: state.isDisabled ? 'not-allowed' : 'default',
    }),
    placeholder: (base, state) => ({
        ...customStyleFilterWrap.placeholder(base, state),
        color: state.isDisabled ? '#6c757d' : '#8d97ad',
    }),
    singleValue: (base, state) => ({
        ...customStyleFilterWrap.singleValue(base, state),
        color: state.isDisabled ? '#6c757d' : '#263238',
    }),
};

class ListLiquidaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: 10,
            isLoadingSellersOptions: false,
            isLoadingEstadosOptions: false,
            seller: {
                label: this.props.filtro?.seller?.label ?? "",
                value: this.props.filtro?.seller?.value ?? ""
            },
            estado: {
                label: this.props.filtro?.estado?.label ?? "",
                value: this.props.filtro?.estado?.value ?? ""
            },
            fechaDesde: this.props.filtro?.fechaDesde ?? fechaFiltro.desde,
            fechaHasta: this.props.filtro?.fechaHasta ?? fechaFiltro.hasta,
            buscaTodo: this.props.filtro?.buscaTodo ?? true,
            showMobileFilters: typeof window === 'undefined' || window.innerWidth >= 768,
            idLiquidacion:
                this.props.filtro?.idLiquidacion != null && this.props.filtro?.idLiquidacion !== ''
                    ? String(this.props.filtro.idLiquidacion)
                    : '',
        };
        this.INITIAL_REQUEST = {
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            numeroPagina: 1,
            tamanoPagina: 10,
            idLiquidacion: '',
        };
    };

    isAuthorizedViewAll = () => [1, 2, 8].includes(this.props.tipoUsuario);

    parseIdLiquidacion = (raw) => {
        const s = String(raw ?? '').trim();
        if (!s) return null;
        const n = parseInt(s, 10);
        return Number.isNaN(n) || n < 1 ? null : n;
    };

    buildLiquidacionesBusquedaRequest = (numeroPagina) => {
        const { fechaDesde, fechaHasta, seller, estado } = this.state;
        const { idSeller, filtro } = this.props;
        const isAuthorizedViewAll = this.isAuthorizedViewAll();
        const page = numeroPagina ?? filtro?.numeroPagina ?? 1;
        const tamanoPagina = this.state.pageSize;
        const idLiq = this.parseIdLiquidacion(this.state.idLiquidacion);

        if (!isAuthorizedViewAll) {
            if (idLiq != null) {
                return {
                    idEstado: 3,
                    idSeller: filtro?.seller ?? idSeller,
                    idLiquidacion: idLiq,
                    numeroPagina: page,
                    tamanoPagina
                };
            }

            const r = {
                fechaDesde,
                fechaHasta,
                idEstado: 3,
                idSeller: filtro?.seller ?? idSeller,
                numeroPagina: page,
                tamanoPagina
            };
            if (idLiq != null) r.idLiquidacion = idLiq;
            return r;
        }

        if (idLiq != null) {
            return {
                idLiquidacion: idLiq,
                numeroPagina: page,
                tamanoPagina
            };
        }

        const request = { fechaDesde, fechaHasta, numeroPagina: page, tamanoPagina };
        const sellerVacio = !seller.value;
        const estadoVacio = !estado.value;
        if (!sellerVacio || !estadoVacio) {
            Object.assign(request, {
                idSeller: seller.value,
                idEstado: estado.value,
            });
        }
        return request;
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        const request = this.buildLiquidacionesBusquedaRequest(selectedPage);
        this.props.setFiltroLiquidaciones({
            ...this.props.filtro,
            fechaDesde: this.state.fechaDesde,
            fechaHasta: this.state.fechaHasta,
            seller: this.state.seller,
            estado: this.state.estado,
            idLiquidacion: this.state.idLiquidacion,
            numeroPagina: selectedPage,
            tamanoPagina: this.state.pageSize
        });
        this.props.fetchLiquidacionesBusqueda(request);
    };

    componentDidMount() {
        if (this.props.liquidaciones?.length > 0) {
            return;
        }

        const isAuthorizedViewAll = this.isAuthorizedViewAll();

        if (!isAuthorizedViewAll) {

            let filtroParams = {
                fechaDesde: this.state.fechaDesde,
                fechaHasta: this.state.fechaHasta,
                idEstado: 3,
                idSeller: this.props.idSeller,
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            }

            this.props.fetchLiquidacionesBusqueda(filtroParams);

        } else {
            if (this.props.isFilterClear) {
                this.buscarSinFiltro();
            } else {
                this.buscarConFiltro();
            }
        }
    }

    buscarSinFiltro = () => {
        const isAuthorizedViewAll = this.isAuthorizedViewAll();

        if (!isAuthorizedViewAll) {
            let request = {
                fechaDesde: this.INITIAL_REQUEST.fechaDesde,
                fechaHasta: this.INITIAL_REQUEST.fechaHasta,
                idEstado: 3, //harcodeado para Liquidada
                idSeller: this.props.idSeller, // Force own seller
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            }
            this.props.fetchLiquidacionesBusqueda(request);
        } else {
            const req = {
                fechaDesde: this.INITIAL_REQUEST.fechaDesde,
                fechaHasta: this.INITIAL_REQUEST.fechaHasta,
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            };
            this.props.fetchLiquidacionesBusqueda(req);
            this.props.setFiltroLiquidaciones({ ...this.INITIAL_REQUEST, numeroPagina: 1, tamanoPagina: this.state.pageSize });
        }
    }

    buscarConFiltro = () => {
        let filtroParams = {
            fechaDesde: this.props.filtro.fechaDesde,
            fechaHasta: this.props.filtro.fechaHasta,
            idSeller: this.props.filtro.seller ?? this.props.idSeller,
            estado: this.props.filtro.estados,
            idLiquidacion: this.props.filtro.idLiquidacion,
            numeroPagina: this.props.filtro.numeroPagina ?? 1,
            tamanoPagina: this.props.filtro.tamanoPagina ?? this.props.filtro.cantidadPagina ?? this.state.pageSize,
        }

        this.props.fetchLiquidacionesBusqueda(filtroParams);

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, liquidaciones: false });
    }

    onLiquidacion = (idSeller, idLiquidacion) => {
        this.props.navigate(`/Liquidaciones/Editar/${idLiquidacion}/${idSeller}`);
    }

    onLiquidacionEditable = (idSeller, idLiquidacion) => {
        this.props.navigate(`/Liquidaciones/EditarBorrador/${idLiquidacion}/${idSeller}`);
    }

    goToCrearLiquidacion = () => {
        this.props.navigate("/Liquidaciones/Nueva");
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;

        if (name === 'idLiquidacion' && String(value ?? '').trim() !== '') {
            this.setState({
                idLiquidacion: value,
                seller: { label: '', value: '' },
                estado: { label: '', value: '' },
            });
            return;
        }

        this.setState({ [name]: value });
    }

    onChangeCheckbox = async (e) => {
        const { name, checked } = e.target;
        this.setState({ [name]: checked });

        this.props.setFiltroLiquidaciones({
            ...this.props.filtroLiquidaciones,
            [name]: checked
        });
    }

    eliminarLiquidacion = (idLiquidacion) => {

        let request = { IdLiquidacion: idLiquidacion };
        let post = putEliminaLiquidacionFinal(request);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("La liquidación fue eliminada con éxito");
        }).catch(err => {
            toast.error("No pudimos eliminar la liquidación");
        });
    }

    onSubmit = (event) => {
        event.preventDefault();

        const { fechaDesde, fechaHasta, buscaTodo, seller = {}, estado = {}, idLiquidacion } = this.state;
        const { filtro, idSeller } = this.props;

        const isAuthorizedViewAll = this.isAuthorizedViewAll();
        const idLiq = this.parseIdLiquidacion(idLiquidacion);

        // Caso para usuarios restringidos (solo ven lo suyo)
        if (!isAuthorizedViewAll) {
            const request = idLiq != null
                ? {
                    idEstado: 3, // hardcodeado para Liquidada
                    idSeller: filtro?.seller ?? idSeller,
                    idLiquidacion: idLiq,
                    numeroPagina: 1,
                    tamanoPagina: this.state.pageSize,
                }
                : {
                    fechaDesde,
                    fechaHasta,
                    idEstado: 3, // hardcodeado para Liquidada
                    idSeller: filtro?.seller ?? idSeller,
                    numeroPagina: 1,
                    tamanoPagina: this.state.pageSize,
                };

            this.props.limpiarLiquidacionesBusqueda();
            this.props.setFiltroLiquidaciones({
                fechaDesde,
                fechaHasta,
                seller,
                estado,
                idLiquidacion: idLiquidacion ?? '',
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            });
            this.props.fetchLiquidacionesBusqueda(request);
            this.setLimpiarFiltroFalse();
            return;
        }

        // Sin ID liquidación: fechas obligatorias
        if (idLiq == null) {
            if (!fechaDesde) {
                toast.warn("Debe seleccionar una fecha inicial");
                return;
            }
            if (!fechaHasta) {
                toast.warn("Debe seleccionar una fecha final");
                return;
            }
        }

        // Actualizar filtro global
        const setFiltroParams = {
            fechaDesde,
            fechaHasta,
            seller,
            estado,
            idLiquidacion: idLiquidacion ?? '',
            numeroPagina: 1,
            tamanoPagina: this.state.pageSize,
        };
        this.props.setFiltroLiquidaciones(setFiltroParams);

        const request = {
            numeroPagina: 1,
            tamanoPagina: this.state.pageSize,
        };
        if (idLiq != null) {
            request.idLiquidacion = idLiq;
        } else {
            request.fechaDesde = fechaDesde;
            request.fechaHasta = fechaHasta;
            const sellerVacio = !seller.value;
            const estadoVacio = !estado.value;
            if (!sellerVacio || !estadoVacio) {
                Object.assign(request, {
                    idSeller: seller.value,
                    idEstado: estado.value,
                });
            }
        }

        this.props.limpiarLiquidacionesBusqueda();
        this.props.fetchLiquidacionesBusqueda(request);
        this.setLimpiarFiltroFalse();
    };


    onClear = (e) => {
        e.preventDefault();
        this.setState(prevState => ({
            ...prevState,
            ...this.INITIAL_REQUEST
        }));
        this.buscarSinFiltro();
    };

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ seller: valor });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ estado: valor });
    }

    mapSellers = async () => {
        if (this.state.isLoadingSellersOptions) return;
        if (Array.isArray(this.props.lista_sellers_liquidaciones) && this.props.lista_sellers_liquidaciones.length > 0) return;
        this.setState({ isLoadingSellersOptions: true });

        try {
            await this.props.fetchSellersFilterLiquidaciones({
                Descripcion: "",
                Page: 1,
                PageSize: 100
            });
        } finally {
            this.setState({ isLoadingSellersOptions: false });
        }
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        if (action.action === 'input-change') {
            this.setState({ isLoadingSellersOptions: true });
            this.props.fetchSellersFilterLiquidaciones({
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            }).finally(() => {
                this.setState({ isLoadingSellersOptions: false });
            });
        }
        return descripcion;
    }

    mapEstados = async () => {
        if (this.state.isLoadingEstadosOptions) return;
        if (Array.isArray(this.props.lista_estados_liquidaciones) && this.props.lista_estados_liquidaciones.length > 0) return;

        this.setState({ isLoadingEstadosOptions: true });
        try {
            await this.props.fetchEstadosLiquidaciones();
        } finally {
            this.setState({ isLoadingEstadosOptions: false });
        }
    }

    render() {
        let liquidaciones = !Array.isArray(this.props.liquidaciones) ? [] : this.props.liquidaciones;
        const isAuthorizedViewAll = this.isAuthorizedViewAll();
        const isSearchById = String(this.state.idLiquidacion ?? '').trim() !== '';
        const blockedSelectPlaceholder = '--';
        const noOptionsMessage = () => 'Sin opciones';
        const loadingOptionsMessage = () => 'Cargando...';
        const sellerValue = isSearchById ? null : this.state.seller;
        const estadoValue = isSearchById ? null : this.state.estado;
        const listaSellers = Array.isArray(this.props.lista_sellers_liquidaciones)
            ? this.props.lista_sellers_liquidaciones.map(s => ({ label: s.label, value: s.value.toString() }))
            : [];

        const pageCount = Math.ceil((this.props.cantidadTotalLiquidacionesBusqueda || 0) / this.state.pageSize);

        return (
            <div className="container gestion-liquidaciones liquidaciones-modulo">
                <LiquidacionesPageHeader
                    title="Gestión de liquidación"
                    subtitle="Administración, búsqueda y seguimiento de liquidaciones del marketplace."
                    actions={isAuthorizedViewAll && (
                        <LiquidacionesBtnCrear onClick={this.goToCrearLiquidacion}>
                            Crear liquidación
                        </LiquidacionesBtnCrear>
                    )}
                />

                <div className="mobile-filter-panel" hidden={!this.state.showMobileFilters}>
                    <form
                        className="form-horizontal form-material gestion-liquidaciones-form"
                        onSubmit={this.onSubmit}
                        onReset={this.onClear}
                    >
                    <LiquidacionesFilterCard
                        actions={(
                            <LiquidacionesFilterActions disabled={this.props.isLoadingLiquidaciones} />
                        )}
                    >
                            <div className="row g-3 align-items-end">
                                    <div className="col-12 col-md-2">
                                        <p className="gestion-liquidaciones-filtro-label mb-0">N° liquidación</p>
                                        <input
                                            type="text"
                                            name="idLiquidacion"
                                            className="form-control"
                                            autoComplete="off"
                                            inputMode="numeric"
                                            onChange={this.myChangeHandler}
                                            value={this.state.idLiquidacion}
                                        />
                                    </div>
                                    <div className="col-12 col-md-2">
                                        <p className="gestion-liquidaciones-filtro-label mb-0">Desde</p>
                                        <input
                                            type={isSearchById ? "text" : "date"}
                                            name="fechaDesde"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            min={fechaDesdeMinima}
                                            value={isSearchById ? '--/--/--' : this.state.fechaDesde}
                                            disabled={isSearchById}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2">
                                        <p className="gestion-liquidaciones-filtro-label mb-0">Hasta</p>
                                        <input
                                            type={isSearchById ? "text" : "date"}
                                            name="fechaHasta"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            min={this.state.fechaDesde}
                                            value={isSearchById ? '--/--/--' : this.state.fechaHasta}
                                            disabled={isSearchById}
                                        />
                                    </div>
                                    
                                    {isAuthorizedViewAll && (
                                        <div className="col-12 col-md-2">
                                            <p className="gestion-liquidaciones-filtro-label mb-0">Seller</p>
                                            <Select
                                                value={sellerValue}
                                                options={listaSellers}
                                                onChange={this.selectSearchHandlerLiquidacionesSeller}
                                                onMenuOpen={this.mapSellers}
                                                onInputChange={this.onSelectSearchInputSellers}
                                                styles={disabledFilterSelectStyles}
                                                {...filterSelectMenuPortalProps}
                                                isLoading={this.state.isLoadingSellersOptions}
                                                loadingMessage={loadingOptionsMessage}
                                                noOptionsMessage={noOptionsMessage}
                                                components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                                placeholder={isSearchById ? blockedSelectPlaceholder : ''}
                                                isDisabled={isSearchById}
                                            />
                                        </div>
                                    )}

                                    {isAuthorizedViewAll && (
                                        <div className="col-12 col-md-2">
                                            <p className="gestion-liquidaciones-filtro-label mb-0">Estado</p>
                                            <Select
                                                value={estadoValue}
                                                options={agregarEstadoCalculada(this.props.lista_estados_liquidaciones)}
                                                onChange={this.selectSearchHandlerLiquidacionesEstado}
                                                onMenuOpen={this.mapEstados}
                                                styles={disabledFilterSelectStyles}
                                                {...filterSelectMenuPortalProps}
                                                isLoading={this.state.isLoadingEstadosOptions}
                                                loadingMessage={loadingOptionsMessage}
                                                noOptionsMessage={noOptionsMessage}
                                                components={{ DropdownIndicator: () => DropDownArrow, LoadingIndicator: () => null }}
                                                placeholder={isSearchById ? blockedSelectPlaceholder : ''}
                                                isDisabled={isSearchById}
                                            />
                                        </div>
                                    )}

                            </div>
                    </LiquidacionesFilterCard>
                    </form>
                </div>

                <div className="mobile-filter-toggle-wrap d-md-none">
                    <button
                        type="button"
                        className="btn btn-sm btn-light border mobile-filter-toggle"
                        onClick={() => this.setState((state) => ({ showMobileFilters: !state.showMobileFilters }))}
                        aria-expanded={this.state.showMobileFilters}
                    >
                        <i className={`fa ${this.state.showMobileFilters ? 'fa-chevron-up' : 'fa-filter'}`} />
                        <span>{this.state.showMobileFilters ? 'Ocultar filtros' : 'Filtrar liquidaciones'}</span>
                    </button>
                </div>

                {this.props.isLoadingLiquidaciones ? (
                    <BigSpinner message="Cargando liquidaciones..." />
                ) : liquidaciones.length === 0 ? (
                    <div className="gestion-liquidaciones-empty">
                        No se encontraron resultados para los filtros seleccionados
                    </div>
                ) : (
                    <>
                        <LiquidacionesListItems
                            liquidaciones={liquidaciones}
                            onLiquidacionFunction={this.onLiquidacion}
                            onLiquidacionEditableFunction={this.onLiquidacionEditable}
                            eliminarLiquidacionFunction={this.eliminarLiquidacion}
                        />
                        {pageCount > 1 && (
                            <div className="gestion-liquidaciones-pagination-wrap">
                                <SafeReactPaginate
                                    previousLabel="Anterior"
                                    nextLabel="Siguiente"
                                    breakLabel="..."
                                    breakClassName="break-me"
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName="pagination liquidacion-detalle-pagination mb-0"
                                    subContainerClassName="pages pagination"
                                    activeClassName="active"
                                    forcePage={(this.props.filtro?.numeroPagina ?? 1) - 1}
                                />
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    isLoadingLiquidaciones: state.liquidaciones.isLoadingLiquidaciones,
    liquidaciones: state.liquidaciones.lista_liquidaciones_busqueda,
    cantidadTotalLiquidacionesBusqueda: state.liquidaciones.cantidadTotalLiquidacionesBusqueda,
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    filtro: state.liquidaciones.filtro,
    isFilterClear: state.general.limpiar.liquidaciones,
    emptyFilters: state.general.limpiar,
    idSeller: state.general.idSeller,
});

export default connect(mapStateToProps, {
    fetchSellersFilterLiquidaciones,
    limpiarLiquidacionesBusqueda,
    fetchLiquidacionesBusqueda,
    fetchEstadosLiquidaciones,
    setFiltroLiquidaciones,
    limpiarFiltros
})(ListLiquidacionesWrapper);
